import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BarChart2Icon, TrendingUpIcon, DollarSignIcon, InfoIcon } from 'lucide-react';
export function MarketIQHome() {
  return <MarketIQLayout activeSection={null} data-id="element-497">
      <div className="max-w-4xl mx-auto py-8 mb-16" data-id="element-498">
        {/* Hero Section */}
        <div className="text-center mb-16" data-id="element-499">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 text-[#002f5f] rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-500">
            <BarChart2Icon className="w-4 h-4" data-id="element-501" />
            Market Intelligence
          </div>
          <h1 className="text-5xl md:text-6xl font-['Oswald'] font-bold text-gray-900 uppercase tracking-wide mb-6" data-id="element-502">
            Real-time USDA Market Data
          </h1>
          <p className="text-xl text-gray-600 font-serif leading-relaxed max-w-3xl mx-auto" data-id="element-503">
            Comprehensive pricing, historical trends, and daily analysis for the
            meat and poultry industry. Powered by advanced analytics from{' '}
            <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-[#002f5f] font-semibold hover:underline" data-id="element-504">
              MeatMarket.ai
            </a>
            .
          </p>
        </div>

        {/* Dashboard Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-505">
          {/* Beef Card */}
          <Link to="/market-iq/beef" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-506">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-507">
              <TrendingUpIcon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-508" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-509">
              Beef Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-510">
              Daily boxed beef cutout values, primal cuts, and historical
              spreads.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-511">
              <div data-id="element-512">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-513">
                  Choice Cutout
                </div>
                <div className="font-bold text-gray-900" data-id="element-514">
                  $3.83{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-515">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-516" />
            </div>
          </Link>

          {/* Pork Card */}
          <Link to="/market-iq/pork" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-517">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-518">
              <DollarSignIcon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-519" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-520">
              Pork Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-521">
              Estimated pork carcass cutout and comprehensive primal values.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-522">
              <div data-id="element-523">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-524">
                  Pork Carcass
                </div>
                <div className="font-bold text-gray-900" data-id="element-525">
                  $0.98{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-526">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-527" />
            </div>
          </Link>

          {/* Chicken Card */}
          <Link to="/market-iq/chicken" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-528">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-529">
              <BarChart2Icon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-530" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-531">
              Chicken Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-532">
              Live chicken reports and whole body trading by size metrics.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-533">
              <div data-id="element-534">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-535">
                  Nat'l Composite
                </div>
                <div className="font-bold text-gray-900" data-id="element-536">
                  $1.29{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-537">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-538" />
            </div>
          </Link>
        </div>

        {/* Info Section */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 flex flex-col md:flex-row gap-8 items-start" data-id="element-539">
          <div className="flex-shrink-0 bg-white p-3 rounded-full border border-gray-200 shadow-sm" data-id="element-540">
            <InfoIcon className="w-6 h-6 text-[#002f5f]" data-id="element-541" />
          </div>
          <div data-id="element-542">
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-543">
              Data Methodology & Sources
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" data-id="element-544">
              Market IQ aggregates daily and weekly reports from the USDA
              Agricultural Marketing Service (AMS). Our integration with
              MeatMarket.ai ensures data is normalized, historically accurate,
              and updated in real-time as reports are published.
            </p>
            <a href="https://meatmarket.ai/documentation?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#002f5f] hover:underline inline-flex items-center gap-1" data-id="element-545">
              Read full methodology
              <ArrowRightIcon className="w-3 h-3" data-id="element-546" />
            </a>
          </div>
        </div>
      </div>
    </MarketIQLayout>;
}